import * as React from "react";

function IconFlask({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-flask" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/flask"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line x1={9} y1={3} x2={15} y2={3} /><line x1={10} y1={9} x2={14} y2={9} /><path d="M10 3v6l-4 11a0.7 .7 0 0 0 .5 1h11a0.7 .7 0 0 0 .5 -1l-4 -11v-6" /></svg>;
}

export default IconFlask;